import { Brand } from '../components/Brand';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n';

/** Shown to everyone except the owner while the app is locked. */
export function Locked() {
  const { logout } = useAuth();
  const t = useT();
  return (
    <div className="auth-page">
      <div className="card auth-card">
        <Brand />
        <h1>{t('Bingo App is locked')}</h1>
        <p className="muted" style={{ margin: 0 }}>
          {t('Access is temporarily unavailable. Your work is saved.')}
        </p>
        <button className="btn btn-block" onClick={() => logout().then(() => window.location.assign('/login'))}>{t('Back to log in')}</button>
      </div>
    </div>
  );
}
